import React, { Component } from 'react';
import { Provider } from 'react-redux';
import { Route, Switch } from 'react-router';
import { ConnectedRouter } from 'connected-react-router';
import './App.css';
import configureStore, { history } from './redux/store/Store';
//Pages
import Home from './pages/Home/Home';
import SelectInput from './pages/SelectInput/SelectInput';
import InputSpeech from './pages/InputSpeech/InputSpeech';
import InputText from './pages/InputText/InputText';
import InputPhoto from './pages/InputPhoto/InputPhoto';
import ResultScreen from './pages/ResultScreen/ResultScreen';
import SubResultScreen from './pages/SubResultScreen/SubResultScreen';
import CustomRoute from './components/CustomRoute/CustomRoute';
import Text2Voice from './components/Text2Voice/Text2Voice';
import InputPhotoValidation from './pages/InputPhoto/InputPhotoValidation/InputPhotoValidation';
import InputSpeechvalidation from './pages/InputSpeech/InputSpeechValidation/InputSpeechValidation';
import VideoPreview from './components/VideoPreview/VideoPreview';
import ImagePreview from './components/ImagePreview/ImagePreview';
import Start from './pages/Start/Start';
import RandomSearch from './pages/RandomSearch/RandomSearch';
import SelectAvatar from './pages/SelectAvatar/SelectAvatar';
import HomepagePreview from './components/HomepagePreview/HomepagePreview';

const store = configureStore("");

class App extends Component {

  /**
   * Main render method
   */
  render() {
    return (
      <Provider store={store}>
        <ConnectedRouter history={history}>
          
          <Switch>
            {/** Public routes */}
            <div className="app-container">
              <div className="center-container">
                <Route exact path="/" component={Start} />
                <Route exact path="/home" component={Home} />
                <Route exact path="/selectavatar" component={SelectAvatar} />
                <Route exact path="/random" component={RandomSearch} />

                <Route exact path="/selectinput" component={SelectInput} />
                <Route exact path="/inputspeech" component={InputSpeech} />
                <Route exact path="/inputtext" component={InputText} />
                <Route exact path="/inputphoto" component={InputPhoto} />
                <Route exact path="/inputphotovalidation" component={InputPhotoValidation} />
                <Route exact path="/inputspeechvalidation" component={InputSpeechvalidation} />
                <CustomRoute path="/subresult" component={SubResultScreen} />
                <CustomRoute path="/result" component={ResultScreen} />
                <Route exact path="/videopreview" component={VideoPreview} />
                <Route exact path="/imagepreview" component={ImagePreview} />
                <Route exact path="/textpreview" component={HomepagePreview} />
              </div>
            </div>

          </Switch>
        </ConnectedRouter>
      </Provider>
    );
  }
}

export default App;